<!-- 保单信息 -->
<template>
  <div>
    <a-form :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
      <div class="title_">
        <div class="cutleft_">保单信息</div>
        <div class="cutoff_"></div>
      </div>
      <a-form-item :label-col="{ span: 3 }" label="起止日期">
        <a-date-picker :disabled-date="disabledDate" :disabled="disabledAll" :showTime="{ defaultValue: moment('00:00:00', 'HH:mm:ss') }" placeholder="开始日期" v-decorator="['baodanData.startdata', { rules: [{ required: true, message: '请选择起始日期！' }] }]" @change="effectiveDateChange" />
        <a-date-picker disabled :showTime="{ defaultValue: moment('23:59:59', 'HH:mm:ss') }" style="margin-left: 20px" placeholder="结束日期" v-model="applicantInfoExpireDate" />
        <span style="margin-left: 24px" v-if="planOffsetDay > 0">共{{ planOffsetDay }}天</span>
        <a-radio-group v-model="mon" @change="onChangemon">
          <a-radio :disabled="disabledAll || (item.key < 6 && RiskInfos.riskInfos[0] && RiskInfos.riskInfos[0].amount == 1000000)" v-for="item in guarantPre" :key="item.key" :value="item.key">{{ item.value }} </a-radio>
        </a-radio-group>
      </a-form-item>
      <div class="title_">
        <div class="cutleft_">投保企业信息</div>
        <div class="cutoff_"></div>
      </div>
      <a-form-item :label-col="{ span: 3 }" label="投保企业名称">
        <a-input v-model="applicantInfo.name" :disabled="disabledAll" v-decorator="['applicantInfo.name', { rules: [{ required: true, message: '请输入投保企业名称' }] }]" placeholder="请输入投保企业名称" @blur="changePolicyName()"></a-input>
      </a-form-item>
      <p style="color: red">
        * 投保人名称中包括如下关键字的企业或团体组织拒保：拆、拆房、房屋、疏浚、脚手架、危险品、幕墙、电梯、铁塔、钢结构、爆破、烟花。
      </p>
      <p style="color: red">* 本产品不承保天津及所辖地区、江苏南通、江苏张家港、江苏常熟、江苏常州地区的企业、河北秦皇岛市青龙满族自治县、河北廊坊市、吉林、黑龙江、辽宁、西藏、新疆、青海、及山东省的石材业和渔业、广东省-江门市地区的家具木材制造业的企业</p>
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="投保企业证件类型">
            <a-select
              :disabled="disabledAll"
              @change="value => handleChange(value, 'idType')"
              v-decorator="[
                'applicantInfo.idType',
                {
                  rules: [{ required: true, message: '请选择投保企业证件类型' }]
                }
              ]"
              placeholder="请选择投保企业证件类型"
            >
              <a-select-option v-for="item in companyIdTypeOptions" :key="item.value" :value="item.value"> {{ item.name }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="12">
					<div class="idNumber-form-item">
						<a-form-item :label-col="{ span: 6 }" label="投保企业证件号码">
							<a-input
								v-model="applicantInfo.idNumber"
								:disabled="true"
								v-decorator="[
									'applicantInfo.idNumber',
									{
										rules: [{ required: true, message: '请输入投保企业证件号码' }]
									}
								]"
								placeholder="请输入投保企业证件号码"
							></a-input>
						</a-form-item>
						<!-- 客服二维码组件 -->
						<customerService></customerService>
					</div>
        </a-col>
      </a-row>

      <a-row>
        <a-col :span="24">
          <a-form-item :label-col="{ span: 3 }" label="行业类别">
            <a-cascader
              :options="industryList"
              :field-names="{ label: 'text' }"
              :disabled="RiskInfos.architecture == 1 || disabledAll"
              :show-search="{ filter }"
              @change="(value, label) => handleChange(value, 'industrycode', label)"
              :fieldNames="{
                label: 'text',
                value: 'value',
                children: 'children'
              }"
              v-decorator="['applicantInfo.industrycode', { rules: [{ required: true, message: '请选择' }] }]"
              placeholder="请选择行业"
            />
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :span="24">
        <a-form-item :label-col="{ span: 3 }" label="联系地址">
          <a-col :span="12">
            <a-cascader
              placeholder="请选择"
              :disabled="disabledAll"
              @change="(value, label) => handleChange(value, 'pacCode', label)"
              v-decorator="[
                'applicantInfo.pacCode',
                {
                  rules: [{ required: true, message: '请输入省市区' }]
                }
              ]"
              :options="addressOptions"
              :fieldNames="{
                label: 'text',
                value: 'value',
                children: 'children'
              }"
              style="float: left; width: 250px"
            />
          </a-col>
          <a-col :span="12">
            <a-input
              v-model="applicantInfo.address"
              :disabled="disabledAll"
              v-decorator="[
                'applicantInfo.address',
                {
                  rules: [{ required: true, message: '请输入联系地址' }]
                }
              ]"
              placeholder="请输入联系地址"
              style="float: left; width: 350px; margin-left: 10px"
            ></a-input>
          </a-col>
        </a-form-item>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="企业联系人姓名">
            <a-input
              :disabled="disabledAll"
              v-model="applicantInfo.contactsname"
              v-decorator="[
                'applicantInfo.contactsname',
                {
                  rules: [{ required: true, message: '请输入企业联系人姓名' }]
                }
              ]"
              placeholder="请输入企业联系人姓名"
            ></a-input>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="企业联系人电话">
            <a-input
              :disabled="disabledAll"
              v-model="applicantInfo.telephone"
              v-decorator="[
                'applicantInfo.telephone',
                {
                  rules: [
                    { required: true, message: '请输入企业联系人电话' },
                    { pattern: $regTest.checkPhone, message: '联系人电话不正确' }
                  ]
                }
              ]"
              placeholder="请输入企业联系人电话"
            ></a-input>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="企业联系人邮箱">
            <a-input
              :disabled="disabledAll"
              v-model="applicantInfo.email"
              v-decorator="[
                'applicantInfo.email',
                {
                  rules: [
                    { required: true, message: '请输入企业联系人邮箱' },
                    { pattern: $regTest.checkEmail, message: '联系人邮箱不正确' }
                  ]
                }
              ]"
              placeholder="请输入企业联系人邮箱"
            ></a-input>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item :label-col="{ span: 6 }" label="支付方式">
            <a-select
              :disabled="disabledAll"
              @change="value => handleChange(value, 'payMethod')"
              style="width: 133px"
              placeholder="请选择支付方式"
              v-decorator="[
                'applicantInfo.payMethod',
                {
                  rules: [{ required: true, message: '请选择支付方式' }],
                  initialValue: '3'
                }
              ]"
            >
              <a-select-option v-for="item in payTypeList" :key="item.value" :value="item.value">
                {{ item.text }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>
      <salInsuredList :columns="columns" :data="salInsuredList" :disabledAll="disabledAll" @delSelect="delSelectpre" @addSelect="addSelectpre" @EduitSelect="eduitSelect"></salInsuredList>
      <a-row :gutter="16">
        <div class="title_">
          <div class="cutleft_">总保费</div>
          <div class="cutoff_"></div>
        </div>
      </a-row>

      <a-row :span="12">
        <a-col :span="8">
          <a-form-item label="保费" :label-col="{ span: 3 }">
            <a-input v-model="applicantInfo.totalPremium" disabled addonAfter="元" />
          </a-form-item>
        </a-col>
        <a-col :span="8" class="add-item">
          <a-form-item label="加费系数">
            <a-input-number
              style="width: 100%;"
              :parser="limitDecimalsP"
              :disabled="disabledAll"
              :max="1.5"
              :step="0.000001"
              v-decorator="[
                'discountfactor',
                {
                  initialValue: discountfactor,
                  rules: [
                    {
                      message: '请输入',
                      required: false
                    }
                  ]
                }
              ]"
              :min="1"
              @blur="addPremiumBlur"
            />
          </a-form-item>
          <span style="font-style:normal;color: red;font-size:12px;margin: 10px 0 0 -20px;flex-shrink: 0;">最多支持六位小数</span>
        </a-col>
       </a-row>
      <a-row :gutter="24" class="btn_list" v-show="disabledAll">
        <div class="title_">
          <div class="cutoff_"></div>
        </div>
        <a-checkbox :disabled="!agreementAllRead" @change="onChangeyueduBtn" style="margin-bottom: 20px"> 投保人已充分阅读、理解并同意<fileView></fileView> </a-checkbox>
      </a-row>
      <a-row class="btn_list">
        <a-col :span="24">
          <a-form-item :wrapper-col="{ span: 12, offset: 10 }">
            <a-button class="btn_color" type="primary" :loading="submitLoad1" v-show="!disabledAll" @click="handleSubmitjyb('save')">
              保存订单
            </a-button>
            <a-button class="btn_color" type="primary" v-show="disabledAll" @click="goBack()">
              返回编辑
            </a-button>
            <a-button style="margin-left: 24px" class="btn_color" type="primary" v-show="disabledAll" @click="handleSubmitjyb()" :loading="submitLoad2">
              立即投保
            </a-button>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
    <!-- 支付的弹窗 -->
    <a-modal :afterClose="handlePayModalClose" class="myModal_" width="500px" title="支付确认" forceRender v-model="showPaySure" @ok="paySure" okText="确定" cancelText="关闭">
      <p
        style="
          text-align: center;
          font-size: 18px;
          margin-bottom: 0;
          padding: 20px;
          line-height: 30px;
        "
      >
        您投保的{{ productName }}需支付保费 <span style="color: #fe8f2d; font-weight: bold">{{ applicantInfo.totalPremium }}</span
        >&nbsp;元
      </p>
    </a-modal>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
// import Vue from 'vue'
import DATA from './../js/data';
import moment from 'moment';
import { policyMixin } from '@/mixins/policyMixin.js';
import { idNumberMixins } from '@/mixins/idNumberMixins.js';
import salInsuredList from './salInsuredList';
let nameEXR = [ "拆", "拆房", "房屋", "疏浚", "脚手架", "危险品", "幕墙", "电梯", "铁塔", "钢结构", "爆破", "烟花" ];  //投保名称限制关键字
export default {
  //import引入的组件需要注入到对象中才能使用
  components: { salInsuredList },
  mixins: [policyMixin, idNumberMixins],
  data() {
    //这里存放数据
    return {
      productName: sessionStorage.getItem('productName'),
      submitLoad1: false, //保存中
      yueduBtn: false, //阅读中
      submitLoad2: false, //提交中
      showPaySure: false, //支付
      postPolicyData: {}, //要提交的数据
      policyId: '', //支付回来的id
      checkVisible: false, //凭证支付
      showQrcodePayModal: false, // 二维码支付
      /**需要的数据开始 */
      applicantInfo: {
        name: '', //投保企业名称
        idType: '', //证件类型
        idNumber: '', //证件号码
        imageUrl: '', //证件图片
        pacCode: '', //省市区
        address: '', //详细地址
        // companyProperty: "", //企业性质
        industrycode: [], //行业类别
        contactsname: '', //联系人名称
        telephone: '', //联系人电话
        email: '', // 邮箱
        // beneficiary: "", // 附加被保险人
        remark: '', //备注
        invoiceprinttype: '03', //发票类型
        taxpayercertificateno: '', //纳税人识别号
        payMethod: '3', //支付方式
        totalPremium: 0, //总保费
        juvenilesAvgpremuim: 0, //单个保费
        expireDate: '',
        effectiveDate: '' //投保期限
      },
      address: '',
      //表格的头部
      columns: DATA.columns,
      //表格的数据
      salInsuredList: [],
      rate: 0.2, //费率
      industrycodeTEXT: '', //四级行业的文本
      discountfactor: '1', //加费系数
      maxType: 1, //最大类别
      companyCode: '01', //企业性质
      planinfos: '0;0;0', //基础保费
      perRiskInfo: '', //险种类
      evidenceNumber: '', //凭证号
      riskNumber: {}, //计算保费
      uniqueArr: [], //去重后的人数列表
      orderContent: {},
      industrycode: [], // 行业类别
      //投保人证件类型
      companyIdTypeOptions: DATA.companyIdTypeOptions,
      //投保的天数
      guarantPre: this.$lodash.cloneDeep(DATA.guarantPre),
      loading: false,
      form: this.$form.createForm(this, { name: 'advanced_search' }),
      RiskInfos: {
        architecture: '0',
        riskInfos: [
          {
            riskCode: '0050', //意外身故/伤残
            amount: 100000,
            riskName: `意外身故/伤残`
          }
        ],
        salPolicy: {
          productCode: '', //产品code
          bracket: 12, //保费期限
          planCode: ''
        },
        salPolicyExt: {
          isworkheightinvolved: '' //行业Name
        },
        salPolicyHolder: {
          addfifty: '1', // 测算类型
          stature: 2 //是否高空（2-否，1-是）
        },
        premiumBaseDtoList: [] //人数
      }, //测算的数据
      modalVisible: false, //修改保费的弹窗
      resultPcontent: {},
      viewPcontent: {}, //展示的保费
      addPcontent: {}, //拷贝的
      creator: '1',
      productCode: '',
      plan: '',
      userParams: {},
      /**需要的数据结束 */
      guapre: 1,
      mon: 12,
      planOffsetDay: 0,
      baodanData: {
        startdata: ''
      },
      startValues: null,
      disabledAll: false, //是否是立即投保
      linshiContent: {},
      // riskInfosAmount:{},//计算险种的结果
      typeNumObj: {
        '1类': 0,
        '2类': 0,
        '3类': 0,
        '4类': 0,
        '5类': 0,
        '6类': 0
      },
      salPolicyExt: {}
    };
  },
  //监听属性 类似于data概念
  computed: {
    addressOptions() {
      //地址code
      // 不承保注册地或营业地在天津市及所辖地区的企业
      // 江苏南通、江苏张家港、江苏常熟、江苏常州地区的企业 河北秦皇岛市青龙满族自治县、河北廊坊市、吉林、黑龙江、辽宁、西藏、新疆、青海
      let ArrCode = '120000 220000 230000 210000 540000 650000 630000 990000';
      let twoArrCode = '131000 320600 320400';
      let threeCode = '130321 320581 320582';
      let dataArr = this.$lodash.cloneDeep(window.addrescode);
      // A04: 渔业 C3033：建筑用石加工
      if (this.industrycode[1] == 'A04' || this.industrycode[3] == 'C3033') {
        ArrCode = '120000 410000 220000 230000 210000 540000 650000 630000 990000 370000';
      }
      if(this.industrycode[1] === 'C21') {
        twoArrCode = '131000 320600 320400 440700';
      }
      dataArr &&
        dataArr.forEach(e => {
          if (ArrCode.indexOf(e.value) > -1) {
            e['disabled'] = true;
          }
          e.children.forEach(element => {
            if (twoArrCode.indexOf(element.value) > -1) {
              element['disabled'] = true;
            }
            element.children.forEach(elements => {
              if (threeCode.indexOf(elements.value) > -1) {
                elements['disabled'] = true;
              }
            });
          });
        });
      return dataArr;
    },
    //行业类别
    industryList() {
      let hangye = window.industrylist;
      return hangye;
    },
    applicantInfoExpireDate() {
      let mon = this.mon;
      let date = this.applicantInfo.effectiveDate;
      let t = '';
      if (date != '') {
        t = moment(date)
          .add(mon, 'M')
          .subtract(1, 's');
      }
      return t;
    }
  },
  //监控data中的数据变化
  watch: {
    'applicantInfo.pacCode'(val) {
      sessionStorage.removeItem('pacCode');
      sessionStorage.setItem('pacCode', val[2].value || null);
    },
    'applicantInfo.industrycode'(val) {
      sessionStorage.removeItem('HYCode');
      sessionStorage.setItem('HYCode', val || null);
    },
    'applicantInfo.name'(val) {
      if (val.indexOf('天津') != -1) {
        this.applicantInfo.name = '';
        this.form.setFieldsValue({
          applicantInfo: {
            name: ''
          }
        });
        this.$message.warning('天津地区企业不可投保');
      }
      nameEXR.forEach(element => {
        if (val.indexOf(element) != -1) {
          this.applicantInfo.name = '';
          this.form.setFieldsValue({
            applicantInfo: {
              name: ''
            }
          });
          this.$message.warning('投保人名称中含以下关键字的企业团体拒保：拆、拆房、房屋、疏浚、脚手架、危险品、幕墙、电梯、铁塔、钢结构、爆破、烟花');
          return;
        }
      });
      if (this.industrycode[1] && this.industrycode[1] == 'A04') {
        // 河南省、河北秦皇岛市青龙满族自治县、河北廊坊市、吉林、黑龙江、辽宁、西藏、新疆、青海、及山东省的石材业和渔业、及广东省-江门市
        if (val.indexOf('山东') != -1) {
          this.applicantInfo.name = '';
          this.form.setFieldsValue({
            applicantInfo: {
              name: ''
            }
          });
          this.$message.warning('该投保人企业不符合投保规则, 不可投保');
        }
      }
      if (this.industrycode[1] && this.industrycode[1] == 'C21') {
        // 河南省、河北秦皇岛市青龙满族自治县、河北廊坊市、吉林、黑龙江、辽宁、西藏、新疆、青海、及山东省的石材业和渔业、及广东省-江门市
        if (val.indexOf('江门') != -1) {
          this.applicantInfo.name = '';
          this.form.setFieldsValue({
            applicantInfo: {
              name: ''
            }
          });
          this.$message.warning('该投保人企业不符合投保规则, 不可投保');
        }
      }
    }
  },
  //方法集合
  methods: {
    moment,
    goBack() {
      //返回编辑
      this.disabledAll = false;
      this.$bus.$emit('disabledBus', false);
      let obj = this.$route.query;
      this.$router.push({
        path: 'hybzxty',
        query: {
          u: obj.u,
          p: obj.p,
          planCode: obj.p,
          sign: obj.sign
        }
      });
    },
    filterPcode(arr) {
      let str;
      if (arr && arr.length) {
        if (isNaN(parseInt(arr[0]))) {
          str = 'text';
        } else {
          str = 'value';
        }
        if (!str) return;
        try {
          var addressOptions = this.$lodash.cloneDeep(this.addressOptions);
          var oneArr = addressOptions.filter(item => arr[0] == item[str]) || [];
          var twoArr = oneArr[0].children.filter(item => arr[1] == item[str]) || [];
          var threeArr = twoArr[0].children.filter(item => item[str] == arr[2]) || [];
          sessionStorage.setItem('pacCode', threeArr[0].value);
        } catch (error) {
          throw new Error(error);
        }
        return {
          code: [oneArr[0] ? oneArr[0].value : '', twoArr[0] ? twoArr[0].value : '', threeArr[0] ? threeArr[0].value : ''],
          arrCode: [oneArr[0], twoArr[0], threeArr[0]]
        };
      }
    },
    queryOrderDetails() {
      // 查询保单信息
      let parms = {
        policyId: this.$route.query.policyId
      };
      this.$api.queryOrderDetails(parms).then(res => {
        if (res.data.returnCode == 0) {
          if (res.data.content) {
            this.orderContent = res.data.content;
            if (res.data.content.salInsuredList) {
              //被保人清单
              this.salInsuredList = res.data.content.salInsuredList;
              this.salInsuredList.forEach((element, i) => {
                let str = element.birthDate;
                element.occupation = [element.occupationCode.substring(0, 2), element.occupationCode.substring(0, 4), element.occupationCode]; //职业类别代码
                element['index'] = i + 1;
                element.birthDate = str.slice(0, 4) + '-' + str.slice(4, 6) + '-' + str.slice(6, 8); //生日
              });
            }
            if (res.data.content.riskInfos) {
              let riskInfos = res.data.content.riskInfos;
              this.$bus.$emit('busRiskInfos', this.$lodash.cloneDeep(riskInfos));
            }
            if (res.data.content.salPolicy) {
              let salPolicy = res.data.content.salPolicy;
              this.plan = salPolicy.productCode;
              this.mon = parseInt(salPolicy.bracket);
              this.$bus.$emit('busGuapre', this.mon);
              this.discountfactor = salPolicy.discountfactor - 0; //加费系数
              this.applicantInfo.mon = parseInt(salPolicy.bracket);
              this.applicantInfo.totalPremium = salPolicy.totalPremium;
              this.applicantInfo.payMethod = salPolicy.payMethod;
              this.applicantInfo.juvenilesAvgpremuim = salPolicy.juvenilesAvgpremuim;
              this.creator = salPolicy.creator;
              this.productCode = salPolicy.productCode;
              this.applicantInfo.effectiveDate = moment(salPolicy.effectiveDate).format('YYYY-MM-DD HH:mm:ss');
              this.baodanData.startdata = this.applicantInfo.effectiveDate;
              this.form.setFieldsValue({
                applicantInfo: {
                  ...salPolicy,
                  effectiveDate: moment(salPolicy.effectiveDate).format('YYYY-MM-DD HH:mm:ss')
                },
                baodanData: {
                  startdata: moment(salPolicy.effectiveDate).format('YYYY-MM-DD')
                }
              });
            }
            if (res.data.content.salPolicyExt) {
              this.salPolicyExt = res.data.content.salPolicyExt
              this.$bus.$emit('busStature', this.salPolicyExt.isworkheightinvolved);//"是否高空，是：1，否：2，默认2"
            }
            if (res.data.content.salPolicyHolderExt) {
              let salPolicyHolderExt = res.data.content.salPolicyHolderExt;
              this.industrycodeTEXT = salPolicyHolderExt.industryname;
            }
            if (res.data.content.salPolicyHolder) {
              let salPolicyHolder = res.data.content.salPolicyHolder;
              this.applicantInfo.name = res.data.content.salPolicyHolder.name;
              this.applicantInfo.pacCode = this.filterPcode([salPolicyHolder.province, salPolicyHolder.city, salPolicyHolder.district] || []).arrCode;
              this.address = salPolicyHolder.address;
              sessionStorage.setItem('HYCode', salPolicyHolder.industrycode);
              this.form.setFieldsValue({
                applicantInfo: {
                  ...salPolicyHolder,
                  industrycode: [salPolicyHolder.industrycode.slice(0, 1), salPolicyHolder.industrycode.slice(0, 3), salPolicyHolder.industrycode.slice(0, 4), salPolicyHolder.industrycode],
                  pacCode: this.filterPcode([salPolicyHolder.province, salPolicyHolder.city, salPolicyHolder.district] || []).code
                }
              });
              this.$nextTick(() => {
                this.form.setFieldsValue({
                  applicantInfo: {
                    taxpayercertificateno: salPolicyHolder.taxpayercertificateno
                  }
                });
              });
            }
            this.salInsuredList = res.data.content.salInsuredList;
            this.riskNumber = this.countTimes(this.salInsuredList);
            this.RiskInfos.premiumBaseDtoList = this.numResult(res.data.content.salInsuredList); //人员类别，处理成每一类的人数
            this.RiskInfos.salPolicy = {
              ...this.RiskInfos.salPolicy,
              ...res.data.content.salPolicy
            };
            this.RiskInfos.salPolicyHolder = {
              ...this.RiskInfos.salPolicyHolder,
              ...res.data.content.salPolicyHolder
            };
            this.RiskInfos.salPolicyHolder.addfifty = '1';
            this.RiskInfos.riskInfos = res.data.content.riskInfos; //险种信息
            this.resultPremiumSum(this.RiskInfos, 'eduit');
          }
        }
      });
    },
    //确认修改
    handleOk() {
      let numResult = 0;
      let sumZfeiyong = DATA.sumZfeiyong(this.addPcontent, this.riskNumber);
      Object.values(sumZfeiyong).forEach(e => {
        numResult += e;
      });
      this.applicantInfo.totalPremium = numResult.toFixed(2);
      this.resultPcontent = this.addPcontent;
      this.modalVisible = false;
    },
    //修改保费
    changePremium() {
      if (JSON.stringify(this.resultPcontent) == '{}') {
        this.$message.error('您还没有计算保费');
        return;
      }
      this.modalVisible = true;
    },
    getterData(data) {
      
      let gerdata = [];
      data.forEach(e => {
        let strArr = [e.name, DATA.getterIdtype(e.idType), e.idNumber, e.birthDate, DATA.getterGender(e.gender), e.occupationCode, '', '', e.occupationName, '', 1, '', e.occulevel.toString().slice(0, 1)];
        gerdata.push(strArr.join(','));
      });
      return gerdata.join(';');
    },
    filter(inputValue, path) {
      return path.some(option => {
        return option.text.toLowerCase().indexOf(inputValue.toLowerCase()) > -1;
      });
    },
    //试算的接口
    resultPremiumSum(data, type) {
      // 若未填投保企业名称不试算，保费系数与投保企业名称有关
      if(!this.applicantInfo.name) {
        return
      }
      let copyData = this.$lodash.cloneDeep(data);
      copyData.premiumBaseDtoList.forEach(e => {
        e.occupationKind = e.occupationKind.toString().slice(0, 1) + '类';
      });
      let formData = {
        architecture: copyData.architecture,
        riskInfos: copyData.riskInfos, //险种信息
        salPolicy: {
          planCode: this.productCode, //产品计划 （固定值ConstructAccident）
          productCode: this.productCode, //productGroupCode  产品组合代码 （固定值ConstructAccident）
          creator: this.creator,
          discountfactor: this.discountfactor, //保单加费比例，保司那边最大6位小数
          bracket: copyData.salPolicy.bracket //保费期限
        },
        salPolicyHolder: {
          name: this.applicantInfo.name,
          addfifty: '1' // 测算类型
        },
        salPolicyExt: {
          isworkheightinvolved: copyData.salPolicyExt.isworkheightinvolved
        },
        premiumBaseDtoList: copyData.premiumBaseDtoList //人数
      };
      this.$api.calPremiumEmployer(formData).then(res => {
        if (res.data.success) {
          let datas = res.data.content;
          this.resultPcontent = datas;
          this.perRiskInfo = this.$lodash.cloneDeep(datas.perRiskInfo);
          delete datas['perRiskInfo'];
          this.viewPcontent = this.$lodash.cloneDeep(datas); //恒定不变的展示用，做限制
          this.addPcontent = this.resoverObj(this.$lodash.cloneDeep(datas).occPremiumMap); //计算用的改变的数据
          if (type != 'eduit') {
            this.applicantInfo.totalPremium = datas.totalPremium; //总保费
          }
        } else {
          this.$message.error(res.data.returnMsg + '错误');
        }
      });
    },
    //反转对象
    resoverObj(obj) {
      var a = {
        '1类': 0,
        '2类': 0,
        '3类': 0,
        '4类': 0,
        '5类': 0,
        '6类': 0
      };
      for (const key in obj) {
        a[key] = obj[key][key];
      }
      return a;
    },
    invoiceprinttypeChange(value) {
      //发票类型更改
      this.applicantInfo.invoiceprinttype = value;
    },
    //选择天数的
    onChangemon(e) {
      this.mon = e.target.value;
      this.$bus.$emit('busGuapre', e.target.value);
      this.RiskInfos.salPolicy.bracket = this.mon;
      if (this.RiskInfos.premiumBaseDtoList.length) {
        this.resultPremiumSum(this.RiskInfos);
      }
      if (this.applicantInfo.effectiveDate) {
        let end = moment(this.startValues)
          .add(this.mon, 'month')
          .subtract(1, 'days');
        let offsetDay = end.diff(this.startValues, 'days') + 1;
        this.planOffsetDay = offsetDay;
        this.form.setFieldsValue({ expireDate: end });
      }
    },
    //处理时间的
    effectiveDateChange(date1, date) {
      this.applicantInfo.effectiveDate = date;
    },
    //开始时间
    disabledDate(current) {
      var dd = new Date();
      dd.setDate(dd.getDate() + 1); //获取AddDayCount天后的日期
      var y = dd.getFullYear();
      var m = dd.getMonth() + 1 < 10 ? '0' + (dd.getMonth() + 1) : dd.getMonth() + 1; //获取当前月份的日期，不足10补0
      var d = dd.getDate() < 10 ? '0' + dd.getDate() : dd.getDate(); //获取当前几号，不足10补0
      var time = y + '-' + m + '-' + d;
      var currents = moment(time);
      return current && current < currents;
    },
    filterSalInsuredList(data) {
      return data.filter(e => {
        delete e['occupation'];
        delete e['mobile'];
        delete e['termOfValidity'];
        delete e['uniqueid'];
        delete e['type'];
        delete e['height'];
        switch (e['gender']) {
          case '男':
            e['gender'] = 'M';
            break;
          case '女':
            e['gender'] = 'F';
            break;
        }
        e['occulevel'] = Number(e.occulevel.toString().slice(0, 1));
        return e.occulevel;
      });
    },
    //计算总保费
    countTimes(data) {
      var a = [];
      if (data.length) {
        data.forEach(e => {
          let leve = e.occulevel.toString().indexOf('类') > -1 ? e.occulevel.toString() : e.occulevel.toString() + '类';
          a.push(leve);
        });
        return a.reduce(function(time, name) {
          if (name in time) {
            time[name]++;
          } else {
            time[name] = 1;
          }
          return time;
        }, {});
      } else {
        return {
          '1类': 0,
          '2类': 0,
          '3类': 0,
          '4类': 0,
          '5类': 0,
          '6类': 0
        };
      }
    },
    //拼接gztypestr字段
    gztypestrPin() {
      var a = {
        1: 0,
        2: 0,
        3: 0,
        4: 0,
        5: 0,
        6: 0
      };
      for (const key in this.resultPcontent) {
        a[key] = this.resultPcontent[key];
      }
      let baofei = Object.values(a).join(';'); //总保费
      this.planinfos = Object.values(a)
        .slice(0, 3)
        .join(';'); //基础保费
      
      var arr = [this.RiskInfos.salPolicyHolder.stature || 2, this.RiskInfos.salPolicy.bracket || 1, this.maxType, this.rate || 0.2, this.industrycodeTEXT || '', this.applicantInfo.industrycode[3] || '', this.salInsuredList.length || 0, baofei];
      return arr.join(';');
    },
    //最后的提交
    handleSubmitjyb(type) {
      let ageStatus = true;
      this.salInsuredList.forEach(e => {
        let age = moment().diff(e.birthDate, 'years');
        if (age < 16 || age > 65) {
          this.$message.error('投保人年龄仅限于16-65周岁，请修改后再试！');
          ageStatus = false;
          return;
        }
      });
      if (!ageStatus) {
        return;
      }
      this.form.validateFields((err, values) => {
        if (!err) {
          if (type == 'save') {
            //保存
            let base = this.applicantInfo;
            let salInsuredList = this.filterSalInsuredList(this.salInsuredList); //表格的数据
            if (salInsuredList.length < 3) {
              this.$message.warning('最低投保人数最低3人');
              return;
            }
            // 不承保广东省-江门市地区的家具木材制造业的企业； 山东省渔业禁止承保。
            let pacCode = sessionStorage.getItem('pacCode') || null;
            let HYCode = sessionStorage.getItem('HYCode') ? sessionStorage.getItem('HYCode').split(',') : [];
            if (pacCode) {
             // 'A04' 山东省渔业禁止承保
             
             if (pacCode.toString().slice(0, 3) == '370') {
                if (HYCode[0].indexOf('A04') > -1 
                || HYCode[1].indexOf('A04') > -1 
                || HYCode[0].indexOf('C3033') > -1
                || HYCode[3].indexOf('C3033') > -1
                ) {
                    this.$message.error(`山东省石材业和渔业不在承保范围内`);
                    return;
                }
              }
              if (pacCode.toString().slice(0, 4) == '4407') {
                if (HYCode[0].indexOf('C21') > -1 || HYCode[1].indexOf('C21') > -1) {
                  this.$message.error(`江门市地区的家具木材制造业不在承保范围内`);
                }
                return;
              }
            }
            let riskInfos = this.RiskInfos && this.RiskInfos.riskInfos.filter(item => item.amount != 0); 
            let data = {
              salInsuredList: this.filterSalInsuredList(this.salInsuredList), //表格的数据
              salPolicy: {
                //保单信息
                discountfactor: this.discountfactor, //加费系数
                planCode: this.productCode, //产品计划 （固定值ConstructAccident）
                productCode: this.productCode, //productGroupCode  产品组合代码 （固定值ConstructAccident）
                creator: this.creator,
                id: this.policyId,
                effectiveDate: moment(values.baodanData.startdata).format('YYYY-MM-DD'), //startTime  保单生效时间
                expireDate: moment(this.applicantInfoExpireDate).format('YYYY-MM-DD'), //endTime   保单终止时间
                payMethod: values.applicantInfo.payMethod, //支付方式”
                bracket: this.RiskInfos.salPolicy.bracket, //页面选择的保障期间（几个月就传几，整数）
                totalPremium: base.totalPremium, //totalPremium  总保费
                coverageamount: '', //totalSumInsured  总保额
                remark: values.applicantInfo.remark, //备注
                ordertraceno: '' //"凭证支付时的凭证号",
              },
              salPolicyHolder: {
                //投保人信息
                addfifty: '2', //测算类型
                type: 'C', //固定值
                schooltype: this.RiskInfos.salPolicyHolder.stature == '1' ? 'Y' : 'N',
                name: values.applicantInfo.name, //name  投保人名称
                idType: values.applicantInfo.idType, //证件类型
                idNumber: values.applicantInfo.idNumber, //certNo   证件号码
                address: values.applicantInfo.address, //详细地址
                contactsname: values.applicantInfo.contactsname, //联系人姓名
                telephone: values.applicantInfo.telephone, //联系人电话
                email: values.applicantInfo.email, //联系人邮箱
                industrycode: values.applicantInfo.industrycode[3], //行业类型
                province: base.pacCode[0].text, //省
                city: base.pacCode[1].text, //市
                district: base.pacCode[2].text, //区
                addresscode: `${base.pacCode[0].value}-${base.pacCode[1].value}-${base.pacCode[2].value}`,
                stature: this.RiskInfos.salPolicyHolder.stature, //"是否高空，是：1，否：2，默认2"
                invoiceprinttype: '03', //"发票类型，电子普通发票：01、暂不开票：03",
                taxpayercertificateno: values.applicantInfo.taxpayercertificateno, //税务号
                taxpayercertificatetype: values.applicantInfo.invoiceprinttype == '01' ? values.applicantInfo.taxpayercertificateno : '01'
              },
              salPolicyHolderExt: {
                industryname: this.industrycodeTEXT
              },
              salPolicyExt: {
                occEmpVersion: this.fileCodeContent.id || this.salPolicyExt.occEmpVersion,
                isworkheightinvolved: this.RiskInfos.salPolicyExt.isworkheightinvolved, //"是否高空，是：1，否：2，默认2"
                architecture: this.RiskInfos.architecture // 是否是建筑行业
              },
              riskInfos: riskInfos
            };
            this.postPolicyData = data;
            // return
            if (this.$route.query.policyId) {
              this.postPolicyData.salPolicy.policyId = this.$route.query.policyId;
            }
            this.submitLoad1 = true;
            this.axiosPolicy('save'); // 保存订单是 直接保存
          } else {
            if (!this.yueduBtn) {
              this.$message.warning('请确认已充分阅读、理解并同意《保险条款》《投保须知》《责任免除》', 2);
              return;
            }
            this.$store.commit('setLoading', {
              show: true,
              text: '核保中，请稍后...'
            });
            this.$api
              .payBeforeUnderwriting(this.$route.query.policyId)
              .then(res => {
                if (res.data.returnCode !== "00") {
                  window.$msg.error({
                    duration: null,
                    message: '提示',
                    description: res.data.returnMsg
                  });
                  return;
                }
                this.submitLoad2 = true;
                this.showPaySure = true;
              })
              .finally(() => {
                this.submitLoad1 = false
                this.$store.commit('setLoading', { show: false });
              });
          }
        } else {
          this.$message.error('请填写完整提交的数据');
        }
      });
    },
    async axiosPolicy(save) {
      //提交保单
      if (save == 'save') {
        await this.$api
          .employerPolicy(this.postPolicyData)
          .then(res => {
            this.submitLoad1 = false
            this.submitLoad2 = false;
            
            if (res.data.returnCode == '00') {
              this.showPaySure = false;
              this.policyId = res.data.content;
              this.$message.success('保存成功！');
              this.$router.push({
                name: 'hybzxty',
                query: {
                  u: this.$route.query.u,
                  p: this.$route.query.p,
                  planCode: this.$route.query.p,
                  sign: this.$route.query.sign,
                  policyId: this.policyId,
                  continuation: '1'
                }
              });
              this.disabledAll = true;
              this.$bus.$emit('disabledBus', true);
            }
          })
          .catch(() => {
            this.submitLoad1 = false;
          })
          .finally(() => {
            this.submitLoad1 = false;
          });
        this.submitLoad1 = false;
      }
      
    },
    paySure() {
      //支付确认
      this.showPaySure = false;
      this.submitLoad1 = false;
      this.submitLoad2 = false;
      this.policyId = this.$route.query.policyId;
      this.$payModal({
        show: true,
        type: 'hybzxty', //产品类型
        policyId: this.policyId, //产品id
        creator: this.creator, //用户id
        payMethod: this.applicantInfo.payMethod, //支付方式
        productCode: this.$route.query.p, //产品code
        totalPremium: this.applicantInfo.totalPremium, //支付总金额
        name: this.applicantInfo.name
      });
    },
    handlePayModalClose() {
      this.showPaySure = false;
      this.submitLoad1 = false;
      this.submitLoad2 = false;
    },
    handleChange(value, type, label) {
      if (type == 'pacCode') {
        this.applicantInfo[type] = label;
        this.address = label.length > 2 ? label[0].text + label[1].text + label[2].text : '';
        sessionStorage.setItem('pacCode', value[2]);
      } else if (type == 'industrycode') {
        sessionStorage.setItem('HYCode', value);
        this.industrycodeTEXT = label ? label.map(item => item.text).join('/') : '';
        this.applicantInfo[type] = value;
        this.industrycode = value; //行业类型
        
        this.form.setFieldsValue({ //切换行业需重新选择联系地址
            applicantInfo: {
                pacCode: ''
            }
        });

        this.address = '';
        sessionStorage.setItem('pacCode', '');
        
        if (value[1] == 'A04') {
          //山东省 石材业渔业 限制地区
          let name = this.applicantInfo.name;
          if (name.indexOf('山东') != -1) {
            this.applicantInfo.name = '';
            this.form.setFieldsValue({
              applicantInfo: {
                name: ''
              }
            });
            this.$message.warning('此地区不可投保石材业、渔业');
          }
        }
        if (value[1] == 'C21') {
          //家具制造业 限制地区
          let name = this.applicantInfo.name;
          if (name.indexOf('江门') != -1) {
            this.applicantInfo.name = '';
            this.form.setFieldsValue({
              applicantInfo: {
                name: ''
              }
            });
            this.$message.warning('此地区不可投保家具制造业');
          }
        }
      } else {
        this.applicantInfo[type] = value;
      }
      if (type == 'idType') {
        this.queryCompanyCodeByName();
      }
    },
    changePolicyName() {
        // 投保企业名称变化需重新试算保费，保费系数与投保企业有关
        if (this.RiskInfos.premiumBaseDtoList.length) {
            this.resultPremiumSum(this.RiskInfos);
        }
        this.queryCompanyCodeByName()
    },
    queryCompanyCodeByName() {
      this.queryCompanyIdNumber(this.applicantInfo.name, this.applicantInfo.idType, this.companyIdTypeOptions);
    },
    addPremiumBlur(val) {
      this.discountfactor = val.target.value;
      if (this.RiskInfos.premiumBaseDtoList.length) {
        this.resultPremiumSum(this.RiskInfos);
      }
    },
    limitDecimalsP(value) {
      let reg = /^(-)*(\d+)\.(\d\d\d\d\d\d).*$/;
      return value.replace(/￥\s?|(,*)/g, '').replace(reg, '$1$2.$3');
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    const { p } = this.$route.query;
    this.productCode = p;
    this.plan = p;
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    if (this.$route.query.policyId) {
      //用户访问页面 取消操作权限
    }
    this.$bus.$on('onRiskInfos', data => {
      let strdata = this.$lodash.cloneDeep(data);
      
      this.RiskInfos.architecture = strdata.architecture;
      this.RiskInfos.riskInfos = strdata.riskInfos;
      this.RiskInfos.salPolicy = strdata.salPolicy;
      this.RiskInfos.salPolicyHolder = strdata.salPolicyHolder;
      this.RiskInfos.salPolicyExt = strdata.salPolicyExt;
      this.mon = Number(strdata.salPolicy.bracket);
      if (this.RiskInfos.premiumBaseDtoList.length) {
        this.resultPremiumSum(this.RiskInfos);
      }
      if (this.RiskInfos.architecture == '1') {
        this.form.setFieldsValue({
          applicantInfo: {
            industrycode: ['E', 'E48', 'E489', 'E4890']
          }
        });
      }
    });
  },
  beforeDestroy() {
    this.$bus.$off('onRiskInfos');
    this.$bus.$off('resultPcontent');
  } //生命周期 - 销毁之前
};
</script>
<style lang="scss" scoped>
.address-fix >>> .ant-form-explain {
  margin-left: 50px;
}
.add-item {
  display: flex;
  ::v-deep {
    .ant-col-5 {
      width: auto;
    }
  }
}
</style>
<style lang="scss">
.avatar-uploader >>> .ant-upload {
  width: 128px;
  height: 128px;
}

.avatar-uploader >>> .ant-upload img {
  width: 100%;
  height: 100%;
}

.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}

.btn_color {
  margin: 0 20px;
}

.user {
  .ant-select,
  .ant-calendar-picker,
  .ant-cascader-picker {
    pointer-events: none !important;
  }

  #myCal {
    pointer-events: none !important;
  }
}
</style>
